import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n/i18n";

/** Company admin: register the existing company in the active edition reusing its latest data. */
export const RenewalCard = () => {
  const { t } = useI18n();
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/applications/renewal").then((x) => setR(x.data)).catch(() => setR(null)); }, []);
  if (!r) return null;
  return (
    <div className="rounded-[24px] border border-slate-200 bg-white p-6" data-testid="portal-renewal">
      <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-upv"><CalendarPlus className="h-3.5 w-3.5" /> {r.edition.title}</p>
      {r.currentApplicationId || r.alreadyParticipating ? (
        <p className="mt-2 text-sm text-slate-600" data-testid="portal-renewal-done">{t("Tu empresa ya participa o tiene una solicitud en esta edición.")} {r.currentApplicationId && <Link to={`/empresas/inscripcion/${r.currentApplicationId}`} className="font-semibold text-upv">{t("Ver solicitud")}</Link>}</p>
      ) : r.registration.open ? (
        <>
          <p className="mt-2 text-sm text-slate-600">{t("Inscribe tu empresa en esta edición: recuperamos tus datos más recientes para que solo tengas que revisarlos.")}</p>
          <Link to="/empresas/inscripcion?renovar=1" className="mt-4 inline-flex h-11 items-center rounded-xl bg-upv px-5 text-sm font-bold text-white hover:bg-upv-dark" data-testid="portal-renewal-start">{t("Inscribir en {year}", { year: r.edition.year })}</Link>
        </>
      ) : (
        <p className="mt-2 text-sm text-slate-600" data-testid="portal-renewal-closed">{r.registration.closedText}</p>
      )}
    </div>
  );
};
